// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
import gosendLogo from 'assets/images/gosendLogo.svg'
import grabLogo from 'assets/images/grabLogo.svg'

export const externalDriverValidator = (logistic_term: any, order_status: any, used: any): any => {
  const allowedStatus = ['new order', 'picking', 'packing', 'waiting driver', 'cancelled']
  const allowedLogistic = ['optional', 'mandatory']

  if (used) {
    return true
  }
  return (
    logistic_term &&
    allowedLogistic.indexOf(logistic_term.toLowerCase()) !== -1 &&
    order_status &&
    allowedStatus.indexOf(order_status.toLowerCase()) !== -1
  )
}

export const parse3plLogo = (provider: any): any => {
  switch (provider.toLowerCase()) {
    case 'grab':
      return (
        <img style={{ width: 51, height: 'auto', marginTop: 6 }} src={grabLogo} alt="grabLogo" />
      )
    case 'gosend':
      return (
        <img
          style={{ width: 51, height: 'auto', marginTop: 6 }}
          src={gosendLogo}
          alt="gosendLogo"
        />
      )
    case 'gojek':
      return (
        <img style={{ width: 51, height: 'auto', marginTop: 6 }} src={gosendLogo} alt="gojekLogo" />
      )
    default:
      return <p>No logo available</p>
  }
}
